(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ante-content-block-timeline"] && !Shopify.designMode) return;
  try {
    if (!(window.CSS && CSS.supports && (CSS.supports("animation-timeline: scroll()") || CSS.supports("animation-timeline: --t")))) {
    const clamp = (value) => Math.min(1, Math.max(0, value))

    const localProgress = (p, a, b) => b === a ? (p * 100 >= a ? 1 : 0) : clamp((p * 100 - a) / (b - a))

    const parseRange = (value, fallback) => (value || fallback).split(" ").map(parseFloat)

    const update = () => {
      const viewport = window.innerHeight
      const lines = document.querySelectorAll(".content-block-timeline .timeline-line.timeline-line-progression")
      for (const line of lines) {
        const container = line.closest(".content-block-timeline")
        if (!container) continue

        const rect = line.getBoundingClientRect()
        const p = clamp((viewport - rect.top) / (viewport + rect.height))

        const mobile = container.clientWidth <= 500
        const lineRange = parseRange(mobile ? line.getAttribute("data-timeline-range-mobile") : line.getAttribute("data-timeline-range"), "10 60")
        line.style.clipPath = "inset(0 0 " + ((1 - localProgress(p, lineRange[0], lineRange[1])) * 100) + "% 0)"

        for (const badge of container.querySelectorAll(".timeline-badge.timeline-badge-progression")) {
          const range = parseRange(badge.getAttribute("data-timeline-range"), "10 18")
          badge.style.opacity = localProgress(p, range[0], range[1])
        }
      }
    }

    const onReady = () => {
      update()
      window.addEventListener("scroll", update, { passive: true })
      window.addEventListener("resize", update)
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", onReady)
    } else {
      onReady()
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-image"] && !Shopify.designMode) return;
  try {
    function destroyVideo(wrapper) {
    const video = wrapper?.querySelector("video")
    if (!video) return

    video.pause()
    video.removeAttribute("src")
    video.load()

    for (const source of video.querySelectorAll("source")) {
      source.remove()
    }

    video.srcObject = null
    wrapper.remove()
  }

  let autoVisibility = null

  function autoVideo(image) {
    return image.querySelector(".ante-image-video-auto video")
  }

  function removeInlineVideo(image) {
    destroyVideo(image._inlineVideo)
    image._inlineVideo = null
    image._inlineActive = false
    image.classList.remove("video-inlined")

    const auto = autoVideo(image)
    if (!auto) return

    // re-observing re-fires the callback against the current position, so a card
    // closed while off screen stays paused instead of playing to nobody
    if (autoVisibility) {
      autoVisibility.unobserve(auto)
      autoVisibility.observe(auto)
    }
  }

  function removeHoverVideo(image) {
    destroyVideo(image._video)
    image._video = null
    image._video_removed = true
    image.classList.remove("video-previewing")
  }

  document.addEventListener("mouseenter", e => {
    const image = e.target.closest?.(".ante-image")
    if (!image || image._inlineActive || image._video) return
    // an autoplaying video is already its own preview
    if (image.classList.contains("video-autoplaying")) return

    const modal = image.dataset.modal ?? image.dataset.video
    if (!modal) return

    image._video_removed = false
    image._video = document.createElement("div")
    image._video.classList.add("ante-image-video-preview")
    image._video.innerHTML = modal

    const video = image._video.querySelector("video")
    video.removeAttribute("controls")
    video.muted = true

    function onReady() {
      if (!image._video_removed && !image._inlineActive) {
        image.append(image._video)
        image.classList.add("video-previewing")
        video.play()
      }
    }

    if (video.readyState >= 2) onReady()
    else video.addEventListener("loadeddata", onReady, { once: true })
  }, true)

  document.addEventListener("mouseleave", e => {
    const image = e.target.closest?.(".ante-image")
    if (!image || image._inlineActive) return
    removeHoverVideo(image)
  }, true)

  document.addEventListener("click", e => {
    const image = e.target.closest?.(".ante-image")

    for (const el of document.querySelectorAll(".ante-image.video-inlined")) {
      if (el !== image) removeInlineVideo(el)
    }

    if (image && image.dataset.video) {
      if (image._inlineActive) return

      let resumeTime = 0
      let resume = false

      const handOver = image._video ? image._video.querySelector("video") : autoVideo(image)
      if (handOver && Number.isFinite(handOver.currentTime) && handOver.currentTime > 0) {
        resumeTime = handOver.currentTime
        resume = true
      }

      const auto = autoVideo(image)
      if (auto) auto.pause()

      removeHoverVideo(image)

      image._inlineActive = true
      image._inlineVideo = document.createElement("div")
      image._inlineVideo.classList.add("ante-image-video-inline")
      image._inlineVideo.innerHTML = image.dataset.video

      const realVideo = image._inlineVideo.querySelector("video")
      realVideo.setAttribute("controls", "")

      if (resume) {
        function applyResume() {
          const duration = Number.isFinite(realVideo.duration) ? realVideo.duration : 0
          realVideo.currentTime = duration > 0 ? Math.min(resumeTime, Math.max(0, duration - 0.05)) : resumeTime
        }
        if (realVideo.readyState >= 1) applyResume()
        else realVideo.addEventListener("loadedmetadata", applyResume, { once: true })
      }

      image.append(image._inlineVideo)
      image.classList.add("video-inlined")
      realVideo.play()
    }
  })

  // Autoplaying videos are gated on visibility: a looped carousel clones its slides,
  // so every one of these exists several times over and playing them all is wasteful.
  if (document.querySelector(".ante-image-video-auto video")) {
    const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches

    autoVisibility = new IntersectionObserver(entries => {
      for (const entry of entries) {
        const image = entry.target.closest(".ante-image")
        if (image && image._inlineActive) continue
        if (entry.isIntersecting) entry.target.play().catch(() => {})
        else entry.target.pause()
      }
    }, { threshold: 0.25 })

    function watchAutoVideos(root) {
      for (const video of root.querySelectorAll?.(".ante-image-video-auto video") || []) {
        if (video._autoWatched) continue
        video._autoWatched = true
        if (!reduceMotion) autoVisibility.observe(video)
      }
    }

    watchAutoVideos(document)

    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue
          if (node.matches?.(".ante-image-video-auto video")) watchAutoVideos(node.parentNode)
          else watchAutoVideos(node)
        }
      }
    }).observe(document.body, { childList: true, subtree: true })

  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-import-main"] && !Shopify.designMode) return;
  try {
    // Text formatting (mirrors ante-text tag syntax, minus server/product-dependent tags)

  window.formatText = (input) => {
    let out = String(input ?? "")

    const escapeAttr = s => String(s).replace(/"/g, "&quot;")

    // Inline SVG icon: [[icon=[svg ...[/svg]]]
    out = out.replace(/\[\[icon=\[svg([\s\S]*?)\[\/svg\]\]\]/gi, (_, body) => {
      const content = body.replace(/\[/g, "<").replace(/\]/g, ">")
      return `<span class="ante-text-svg"><svg${content}</svg></span>`
    })

    // Icon: [[icon=...]] (url -> img, b-name -> brand, else solid)
    out = out.replace(/\[\[icon=([\s\S]*?)\]\]/gi, (_, value) => {
      const v = value.trim()
      if (/^https?:/i.test(v)) return `<span class="ante-text-icon-wrap"><img class="ante-text-icon" src="${escapeAttr(v)}" alt=""></span>`
      if (v.slice(0, 2) === "b-") return `<i class="fa-brands fa-${v.slice(2)}"></i>`
      return `<i class="fa-solid fa-${v}"></i>`
    })

    // Countdown: [[countdown=start,duration]]
    out = out.replace(/\[\[countdown=([\s\S]*?)\]\]/gi, (_, params) =>
      `<span class="ante-countdown" data-params="${escapeAttr(params)}"></span><script>{const el=document.currentScript.previousElementSibling;const[start,duration]=el.dataset.params.split(",").map(Number);const fmt=n=>String(n).padStart(2,"0");function tick(){const now=Math.floor(Date.now()/1000);const elapsed=now-start;if(elapsed<0){el.textContent=fmt(Math.floor(duration/3600))+":"+fmt(Math.floor(duration/60)%60)+":"+fmt(duration%60);setTimeout(tick,1000);return}const remaining=duration-(elapsed%duration);if(remaining<=0){el.textContent="00:00:00";return}el.textContent=fmt(Math.floor(remaining/3600))+":"+fmt(Math.floor(remaining/60)%60)+":"+fmt(remaining%60);setTimeout(tick,1000)}tick()}<\/script>`
    )

    // Tooltip: [tooltip=text]content[/tooltip]
    out = out.replace(/\[tooltip=([\s\S]*?)\]([\s\S]*?)\[\/tooltip\]/gi, (_, text, content) =>
      `<span data-easy-tooltip="${escapeAttr(text)}">${content}</span>`
    )

    // Colour / opacity
    out = out.replace(/\[color=([\s\S]*?)\]([\s\S]*?)\[\/color\]/gi, (_, value, body) =>
      `<span style="color: ${value} !important;">${body}</span>`
    )
    out = out.replace(/\[opacity=([\s\S]*?)\]([\s\S]*?)\[\/opacity\]/gi, (_, value, body) =>
      `<span style="opacity: ${value};">${body}</span>`
    )

    // Tag style: [tag=1]content[/tag]
    out = out.replace(/\[tag=([\s\S]*?)\]([\s\S]*?)\[\/tag\]/gi, (_, value, body) =>
      `<span class="ante-text-tag ante-tag-${value}">${body}</span>`
    )

    // Link: [link=href]content[/link]
    out = out.replace(/\[link=([\s\S]*?)\]([\s\S]*?)\[\/link\]/gi, (_, href, body) =>
      `<a class="link" href="${escapeAttr(href)}">${body}</a>`
    )

    // Bold / italic shorthand
    out = out.replace(/\[bold\]([\s\S]*?)\[\/bold\]/gi, "<strong>$1</strong>")
    out = out.replace(/\[italic\]([\s\S]*?)\[\/italic\]/gi, "<em>$1</em>")

    // Wrapper tags (size / weight / colour / decoration / visibility / headings)
    const wrappers = [
      ["h1", "<h1>$1</h1>"],
      ["h2", "<h2>$1</h2>"],
      ["h3", "<h3>$1</h3>"],
      ["h4", "<h4>$1</h4>"],
      ["h5", "<h5>$1</h5>"],
      ["h6", "<h6>$1</h6>"],
      ["small", '<span class="body-small">$1</span>'],
      ["x-small", '<span class="body-x-small">$1</span>'],
      ["large", '<span class="body-large">$1</span>'],
      ["base", '<span class="body-base">$1</span>'],
      ["caption-small", '<span class="body-caption-small">$1</span>'],
      ["caption-x-small", '<span class="body-caption-x-small">$1</span>'],
      ["display", '<span class="text-display">$1</span>'],
      ["callout-large", '<span class="text-callout-large">$1</span>'],
      ["callout", '<span class="text-callout">$1</span>'],
      ["callout-small", '<span class="text-callout-small">$1</span>'],
      ["highlight", '<span class="ante-brand highlight">$1</span>'],
      ["muted", '<span class="muted">$1</span>'],
      ["faint", '<span class="faint">$1</span>'],
      ["alt", '<span style="color: var(--color-text-alt);">$1</span>'],
      ["true", '<span style="color: var(--color-true);">$1</span>'],
      ["false", '<span style="color: var(--color-false);">$1</span>'],
      ["underline", "<u>$1</u>"],
      ["strikethrough", '<span style="text-decoration: line-through;">$1</span>'],
      ["desktop", '<span class="desktop">$1</span>'],
      ["mobile", '<span class="mobile">$1</span>']
    ]

    for (const [tag, replacement] of wrappers) {
      const openPlaceholder = ` O_${tag} `
      const closePlaceholder = ` C_${tag} `
      out = out
        .split(`[[${tag}]]`).join(openPlaceholder)
        .split(`[[/${tag}]]`).join(closePlaceholder)
      out = out.replace(new RegExp(`\\[${tag}\\]([\\s\\S]*?)\\[\\/${tag}\\]`, "gi"), replacement)
      out = out
        .split(openPlaceholder).join(`[${tag}]`)
        .split(closePlaceholder).join(`[/${tag}]`)
    }

    out = out
      .split("[[mobile-br]]").join('<br class="mobile">')
      .split("[[separator]]").join('<span class="text-separator"></span>')
      .split("#javascript:").join("javascript:")

    return out
  }

  // Smooth scrolling

  window.getStickyTop = () => {
    const el = document.createElement("div")
    el.style.position = "fixed"
    el.style.top = "var(--sticky-top, 64px)"
    el.style.left = "0"
    el.style.width = "0"
    el.style.height = "0"
    el.style.pointerEvents = "none"
    el.style.visibility = "hidden"
    document.body.appendChild(el)
    const value = el.getBoundingClientRect().top
    el.remove()
    return value
  }

  function getElementTop(el) {
    let offset = 0
    if (el.classList.contains("ante-section")) {
      const child = el.firstElementChild
      if (child) {
        offset = parseFloat(getComputedStyle(child).paddingTop) || 0
      }
    } else if (el.classList.contains("ante-container")) {
      offset = parseFloat(getComputedStyle(el).paddingTop) || 0
    } else {
      if (Math.round(el.clientWidth) === document.documentElement.clientWidth) {
        offset = parseFloat(getComputedStyle(el).paddingTop) || 0
      }
    }

    let extra = 0
    let p = el.parentElement
    while (p) {
      if (getComputedStyle(p).position === "sticky" && p.parentElement) {
        const gap = p.parentElement.getBoundingClientRect().bottom - p.getBoundingClientRect().bottom
        if (gap > 0) extra += gap
      }
      p = p.parentElement
    }

    return el.getBoundingClientRect().top + window.scrollY - getStickyTop() + offset + extra
  }

  window.smoothScroll = (element, args = {}) => {
    let el = element

    while (el && getComputedStyle(el).display === "none") {
      el = el.nextElementSibling
    }

    if (!el) el = element

    if (args.lazy) {
      const rect = el.getBoundingClientRect()
      if (rect.top >= getStickyTop() && rect.bottom <= window.innerHeight) return
    }

    let attempts = 0
    let lastTop = null

    // nearest travels the least distance that puts the element on screen, rather than
    // pulling it to the top, leaving a small section spacer of room so it doesn't land
    // flush against the bottom edge. Anything already in view stays where it is.
    function nearestPadding() {
      // --section-spacer is fluid, so it has to be measured rather than parsed.
      const probe = document.createElement("div")
      probe.style.cssText = "position:absolute;visibility:hidden;height:var(--section-spacer-small)"
      document.body.append(probe)
      const px = probe.getBoundingClientRect().height
      probe.remove()
      return px
    }

    const pad = args.nearest ? nearestPadding() : 0

    function targetTop() {
      const top = getElementTop(el)
      if (!args.nearest) return top

      const rect = el.getBoundingClientRect()
      const ceiling = getStickyTop()

      if (rect.top >= ceiling && rect.bottom + pad <= window.innerHeight) return window.scrollY
      if (rect.bottom + pad > window.innerHeight) {
        // Coming up from below, but never past the point where it sits at the top.
        return Math.min(window.scrollY + rect.bottom + pad - window.innerHeight, top)
      }
      return top
    }

    function scroll() {
      const top = targetTop()
      if (lastTop !== null && Math.abs(top - lastTop) < 2) return
      lastTop = top

      window.scrollTo({ top, behavior: "smooth" })
      attempts++
      if (attempts < 4) setTimeout(scroll, 500)
    }

    scroll()
  }

  function handleHash(id) {
    const escaped = CSS.escape(id)
    const modalMatches = Array.from(document.querySelectorAll(`#modal-content-${escaped}`))
    if (modalMatches.length) {
      const modalContent = modalMatches[modalMatches.length - 1]
      showAnchorModal(JSON.parse(modalContent.textContent))
      return true
    }

    const target = document.querySelector(id.startsWith(".") || id.startsWith("[") ? id : `#${escaped}`)
    if (!target) return false

    smoothScroll(target)
    history.replaceState(null, "", window.location.pathname + window.location.search)
    return target
  }

  if (window.location.hash) {
    const hash = window.location.hash.slice(1)
    history.replaceState(null, "", window.location.pathname + window.location.search)
    window.scrollTo(0, 0)
    try { handleHash(hash) } catch (e) {}
  }

  document.body.addEventListener("click", e => {
    const link = e.target.closest("a[href*='#']")
    if (!link) return

    const href = link.getAttribute("href")
    const hashIndex = href.indexOf("#")
    if (hashIndex === -1) return
    const id = href.slice(hashIndex + 1)
    if (!id) return

    const before = href.slice(0, hashIndex)
    if (before && before !== window.location.pathname && before !== window.location.origin + window.location.pathname) return

    const target = handleHash(id)
    if (!target) return

    e.preventDefault()

    if (target !== true && "click" in link.dataset) {
      if (target.previousElementSibling?.type == "checkbox" && target.previousElementSibling?.checked) {
        return
      }
      target.click()
    }
  })

  // Show cart

  window.showCart = () => {
    if (window.SlideCart) SlideCart.load()
    else if (window.SLIDECART_OPEN) SLIDECART_OPEN()
    else if (window.Rebuy?.SmartCart) Rebuy.SmartCart.show()
    else window.location = "/cart"
  }

  // Add to cart

  window.addToCart = async ({ items, discount, clearCart, clearDiscount, location: redirect, postAddCartSyncDelay = 0 }) => {
    items = items.map(item => ({
      ...item,
      properties: {
        // derived, but listed first so a caller that sets it explicitly still wins
        _subscription: item.selling_plan ? "true" : "false",
        ...(item.properties || {}),
        _from: [window._template?.name, window._template?.suffix].filter(Boolean).join("."),
        ...(window.anteAd?.() ? { _ad: window.anteAd() } : {})
      }
    }))

    const normalizedRedirect = String(redirect || "").trim()
    const cartRedirect = normalizedRedirect === "/cart"

    let opened = false
    let openTimeout
    if (cartRedirect && window.SlideCart) {
      openTimeout = setTimeout(() => {
        opened = true
        SlideCart.show()
        SlideCart.showMessage(SlideCart.messages.adding)
      }, 250)
    }

    if (clearCart) await fetch("/cart/clear.js")

    if (discount || clearDiscount) await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount: "" })
    })

    const bundleSections = cartRedirect && window.SlideCart && !discount

    const addRequest = fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items, sections: bundleSections ? window.SlideCart.sectionId : undefined })
    })

    // SlideCart applies the discount sequentially so it can show a message; without it there's no message, so fire the discount in parallel for actual speed.
    const discountRequest = discount && cartRedirect && !window.SlideCart ? fetch(`/discount/${encodeURIComponent(discount)}`) : null

    const [r] = await Promise.all([addRequest, discountRequest].filter(Boolean))

    if (openTimeout) clearTimeout(openTimeout)

    if (!r.ok) {
      if (opened) SlideCart.refresh()
      throw new Error(await r.text())
    }

    let addedSections = null
    if (bundleSections) {
      try { addedSections = (await r.json()).sections?.[window.SlideCart.sectionId] || null } catch (_) {}
    }

    if (discount && cartRedirect && window.SlideCart) {
      if (!opened) {
        opened = true
        SlideCart.show()
      }
      SlideCart.showMessage(SlideCart.messages.applyingDiscount)
      await fetch(`/discount/${encodeURIComponent(discount)}`)
    }

    // Shipping discount rules count the cart's own lines, so this can only run once the
    // add has landed. A redirect that leaves the page must wait for it, since the cart is
    // read at checkout; the slide cart and the no-redirect case can let it settle behind
    // the scenes. Optional chaining because the controller section is per-store.
    const shippingRules = window.anteShippingDiscounts?.sync()
    if (normalizedRedirect && !cartRedirect) await shippingRules

    if (cartRedirect) {
      if (window.SlideCart) {
        if (!opened) SlideCart.show()
        await SlideCart.refresh(null, { sections: addedSections })

        if (postAddCartSyncDelay > 0) {
          window.setTimeout(async () => {
            try {
              const latestCart = await fetch("/cart.js").then(response => response.json())
              document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                  baseEvent: "variant:add",
                  cart: latestCart
                }
              }))
              await SlideCart.refresh(latestCart, { silent: true })
            } catch (error) {
              console.warn("Post add cart sync failed", error)
            }
          }, postAddCartSyncDelay)
        }
      } else if (window.SLIDECART_OPEN) {
        if (window.SLIDECART_UPDATE) SLIDECART_UPDATE(SLIDECART_OPEN)
        else SLIDECART_OPEN()
      } else {
        window.location = "/cart"
      }
      return
    }

    if (!normalizedRedirect) return

    window.location = discount
      ? `/discount/${encodeURIComponent(discount)}?redirect=${encodeURIComponent(normalizedRedirect)}`
      : normalizedRedirect
  }

  // Add bundle to cart

  const BUNDLE_PRIME = 2147483647
  const BUNDLE_BASE = 31

  const bundleGcd = (a, b) => (b === 0 ? a : bundleGcd(b, a % b))

  const bundleId = (items) => {
    const g = items.map(i => i.quantity).reduce(bundleGcd)
    let sum = 0
    for (const i of items) {
      const q = Math.min(i.quantity / g, 9999)
      const s = `${i.id}${String(q).padStart(4, "0")}`
      let h = 0
      for (const d of s) {
        h = (h * BUNDLE_BASE + Number(d)) % BUNDLE_PRIME
      }
      sum = (sum + h) % BUNDLE_PRIME
    }
    return sum
  }

  window.addBundleToCart = async (lines, { name = "Bundle", image, discount, clearCart, clearDiscount, location, postAddCartSyncDelay = 0, extras = [] } = {}) => {
    const totals = {}
    for (const l of lines) {
      totals[l.id] = (totals[l.id] || 0) + l.quantity
    }
    const magic = bundleId(Object.entries(totals).map(([id, quantity]) => ({ id, quantity })))
    const metaVariant = Object.keys(totals).reduce((a, b) => (Number(a) < Number(b) ? a : b))
    let metaAssigned = false
    const items = lines.map(l => {
      const isMeta = !metaAssigned && String(l.id) === String(metaVariant)
      if (isMeta) metaAssigned = true
      return {
        ...l,
        id: parseInt(l.id, 10),
        properties: {
          ...(l.properties || {}),
          _pxl_bundle: "true",
          _pxl_bundle_id: String(magic),
          ...(isMeta ? { _pxl_bundle_name: name, ...(image ? { _pxl_bundle_image: image } : {}) } : {})
        }
      }
    })
    return addToCart({ items: items.concat(extras), discount, clearCart, clearDiscount, location, postAddCartSyncDelay })
  }

  // Newsletter

  if (location.search.includes("customer_posted=true") && location.hash === "#newsletter") {
    openModal("Signed up!", "Thanks for subscribing to our newsletter!")
    const url = new URL(location)
    url.searchParams.delete("customer_posted")
    history.replaceState(null, "", url.pathname + url.search)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-import-modals"] && !Shopify.designMode) return;
  try {
    const modals = document.createElement("div")
  modals.id = "modals"
  if (window.anteModalColourTheme) {
    modals.classList.add(`color-theme-${window.anteModalColourTheme}`)
  }
  document.body.append(modals)

  function makeModal(title, content, id, args = {}) {
    const container = document.createElement("div")
    if (id) {
      container.id = id
    }
    container.classList.add("modal-container")
    if (args.type) {
      container.classList.add(`modal-type-${args.type}`)
    }
    container.setAttribute("tabindex", "-1")
    container.innerHTML = `
      <div class="modal-element">
        <div class="modal-title-row">
          <div class="modal-title">${title ?? "Modal"}</div>
          <button class="modal-close" aria-label="Close">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="modal-contents ante-section"></div>
      </div>
    `
    const contents = container.querySelector(".modal-contents")
    if (typeof content === "string") {
      contents.innerHTML = content
    } else {
      contents.append(...content.map(node => node.cloneNode(true)))
    }
    return container
  }

  function handleModal(modal, close, func) {
    modal.querySelector(".modal-title-row .modal-close").addEventListener("click", close)
    let down
    modal.addEventListener("mousedown", e => down = e.target)
    modal.addEventListener("mouseup", e => {
      if (down === e.target && e.target.classList.contains("modal-container")) {
        close()
      }
    })
    modal.addEventListener("keydown", e => {
      if (e.key === "Escape") {
        close()
      } else if (e.key === "Tab") {
        const focusable = modal.querySelectorAll(
          'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
        )
        if (!focusable.length) return
        const first = focusable[0]
        const last = focusable[focusable.length - 1]
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault()
          last.focus()
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault()
          first.focus()
        }
      }
    })
    if (modal.classList.contains("modal-type-slideout")) {
      const el = modal.querySelector(".modal-element")
      const header = modal.querySelector(".modal-title-row")
      const sheet = window.matchMedia("(max-width: 768px)")
      let startY = 0, delta = 0, lastY = 0, lastT = 0, velocity = 0, height = 0, dragging = false
      header.addEventListener("pointerdown", e => {
        if (!sheet.matches || e.button !== 0 || e.target.closest(".modal-close")) return
        dragging = true
        startY = lastY = e.clientY
        lastT = e.timeStamp
        delta = velocity = 0
        height = el.offsetHeight
        el.style.transition = "none"
        header.setPointerCapture(e.pointerId)
      })
      header.addEventListener("pointermove", e => {
        if (!dragging) return
        delta = Math.min(Math.max(0, e.clientY - startY), height)
        if (e.timeStamp > lastT) velocity = (e.clientY - lastY) / (e.timeStamp - lastT)
        lastY = e.clientY
        lastT = e.timeStamp
        el.style.transform = `translateY(${delta}px)`
      })
      function endDrag() {
        if (!dragging) return
        dragging = false
        el.style.transition = ""
        if (delta > height * 0.25 || velocity > 0.6) close()
        el.style.transform = ""
      }
      header.addEventListener("pointerup", endDrag)
      header.addEventListener("pointercancel", endDrag)
    }

    modals.append(modal)
    if (func) {
      modal.modalElement = modal.querySelector(".modal-element")
      modal.modalElement.close = close
      func(modal.modalElement)
    }
  }

  window.openModal = (title, content, id, func, args = {}) => {
    return new Promise(fulfil => {
      const modal = makeModal(title, content, id, args)
      modal.classList.add("opening")
      function close() {
        if (modal.modalElement?.locked) return
        modal.classList.remove("open")
        modal.classList.add("closing")
        const modalElement = modal.querySelector(".modal-element")
        modalElement.addEventListener("transitionend", function handler(e) {
          if (e.target !== modalElement) return
          modalElement.removeEventListener("transitionend", handler)
          modal.remove()
          const all = modals.querySelectorAll(".modal-container")
          if (all.length) {
            all[all.length - 1].focus()
          }
          fulfil()
        })
      }
      handleModal(modal, close, func)
      void modal.offsetWidth
      modal.classList.remove("opening")
      modal.classList.add("open")
      const focusable = modal.querySelectorAll(
        'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
      )
      if (focusable.length > 1) {
        focusable[1].focus()
      } else {
        modal.focus()
      }
    })
  }

  document.addEventListener("click", e => {
    const el = e.target.closest("[data-modal], .modal")
    if (!el) return

    if (el.hasAttribute("data-modal")) {
      openModal(
        el.dataset.modalTitle,
        el.dataset.modal,
        el.dataset.modalId,
        null,
        el.dataset.modalType
      )
      return
    }

    const modals = document.querySelectorAll(".modal")
    for (const modal of modals) {
      if (!modal.dataset.trigger) continue
      if (e.target.closest("." + modal.dataset.trigger)) {
        if (!modal._modalData) {
          modal._modalData = {
            title: modal.dataset.title,
            content: [...modal.children],
            id: modal.dataset.modalId ?? modal.dataset.trigger + "-modal",
            type: modal.dataset.modalType
          }
        }

        const d = modal._modalData
        openModal(d.title, d.content, d.id, null, d.type)
        return
      }
    }
  })

  function showAnchorModal(data) {
    history.replaceState(null, "", location.pathname + location.search)
    let style = "<style>"
    if (data.width > 0) {
      style += `.modal-contents { width: clamp(var(--modal-min-width), var(--width-${data.width}), var(--modal-max-width)); }\n`
      style += `@media (max-width: 1440px) { .modal-contents { width: clamp(var(--modal-min-width), var(--width-${data.widthSmallDesktop}), var(--modal-max-width)); } }\n`
      style += `@media (max-width: 1024px) { .modal-contents { width: clamp(var(--modal-min-width), var(--width-${data.widthTablet}), var(--modal-max-width)); } }\n`
      style += `@media (max-width: 600px) { .modal-contents { width: clamp(var(--modal-min-width), var(--width-${data.widthMobile}), var(--modal-max-width)); } }\n`
    }
    let content = ""
    const id = data.contentType === "video" ? "video-modal" : "modal-" + Math.random().toString(16).replace("0.", "")
    if (data.contentType === "with_image") {
      content += `
        <div class="modal-with-image-top">
          <div class="richtext">${data.content.imageContent}</div>
          ${data.content.image ? `<img src="${data.content.image}">` : ""}
        </div>
        ${data.content.secondaryContent ? `<div class="richtext">${data.content.secondaryContent}</div>` : ""}
      `
      style += `
        .richtext .modal-with-image-top {
          display: flex !important;
          flex-direction: row;
          gap: var(--spacing-medium);
          margin-bottom: var(--spacing-small);
          align-items: center;
        }

        .modal-with-image-top:nth-last-child(3) {
          margin-bottom: var(--spacing-small);
        }

        .modal-with-image-top:first-child {
          flex: 1;
          align-self: flex-start;
        }

        .modal-with-image-top img {
          max-width: min(100%, ${data.content.imageWidth}px);
        }

        @media (max-width: 600px) {
          .modal-with-image-top {
            flex-direction: column !important;
          }
        }
      `
    } else if (data.contentType === "iframe") {
      content += `<iframe src="${data.content.iframeURL}"></iframe>`
      style += `
        #${id} .modal-contents {
          padding: 0;
        }
        
        #${id} iframe {
          display: block;
          border: none;
          width: 100%;
          height: var(--modal-max-height);
        }
      `
    } else if (data.contentType === "images") {
      content += data.content.images.map(e => `<img src="${e}">`).join("")
    } else if (data.contentType === "video") {
      content += `<video controls playsinline src="${data.content.video}"${data.content.autoplay ? " autoplay" : ""}></video>`
    } else {
      content += data.content.content
    }
    style += "</style>"
    if (style !== "<style></style>") {
      content += style
    }
    openModal(data.content.title, `<div class="richtext">${content}</div>`, id, null, data)
  }
  window.showAnchorModal = showAnchorModal
  } catch(e) { console.error(e); }
})();

})();
